import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import creds from './dev-token.json'

export interface UserProfile {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  error: string;
}

export interface UserClaim {
  UserId: string;
  SchoolId: string;
  RefRoleId: string;
  SchoolYear: string;
  IsDisabled: string;
  IsSuperAdmin?: string;
  UserAccess: string;
  nbf: number;
  exp: number;
  iat: number;
  iss: string;
  aud: string;
}

// @Injectable()
export const USER_PROFILE: UserProfile = Object.assign(JSON.parse(localStorage.getItem('userProfile') || '{}'));
export const USER_CLAIM: UserClaim = Object.assign(JSON.parse(localStorage.getItem('userClaim') || '{}'));

export class ConstantsService {
  constructor() {}

  public otCalculation = {
    typeOption: [
      { name: "Weekend", value: "Weekend"},
      { name: "Weekday", value: "Weekday"},
      { name: "Public Holiday", value: "Public Holiday"}
    ],
    calculationTypeOption: [
      { name: "Hourly", value: "Hourly"},
      { name: "Lumpsum", value: "Lumpsum"}
    ]
  }

  public discountType = {
    typeOption: [
      { name: "Staff", value: "Staff"},
      { name: "Second Student", value: "Second Student"}
    ]
  }

  public calendar = {
    monthOption: [
      { name: "Registration", value: 0},
      { name: "January", value: 1},
      { name: "February", value: 2},
      { name: "March", value: 3},
      { name: "April", value: 4},
      { name: "May", value: 5},
      { name: "June", value: 6},
      { name: "July", value: 7},
      { name: "August", value: 8},
      { name: "September", value: 9},
      { name: "October", value: 10},
      { name: "November", value: 11},
      { name: "December", value: 12},
    ]
  }
}
